export default __webpack_public_path__ + "static/ifa-logo-gray-d73329b667f835958058a8ceffbd7824.png";